import { CodeForm } from "../../components/authentication/code/CodeForm";
import { SignUpForm } from "../../components/authentication/signUp/SignUpForm";
import { useUserStore } from "../../stores/useUserStore";
import styles from './signUp.module.css'

export function SignUp() {
    const { user } = useUserStore();



    if (user) {
        return <div className={styles.container}>
            <CodeForm />
        </div>
    }


    return (
        <div className={styles.container}>
            <SignUpForm />
        </div>
    )
}



